import createSnackbar from "../Utils/snackbar"
import instance from "../Utils/instance"

export const getPermissionsRequirementCategoriesAction = body => {
  const REQUEST = instance({
    method: 'get',
    url: 'settings/permissions/requirements/get_category.php'
  })
  return {
    type: "GET_PERMISSION_REQUIREMENT_CATEGORIES",
    payload: REQUEST
  }
}

export const getPermissionsRequirementsAction = body => {
  const REQUEST = instance({
    method: 'get',
    url: 'settings/permissions/requirements/get.php',
    params: body
  })
  return {
    type: "GET_PERMISSION_REQUIREMENTS",
    payload: REQUEST
  }
}

export const createPermissionsRequirementCategoryAction = body => {
  const REQUEST = instance({
    method: 'post',
    url: 'settings/permissions/requirements/create_category.php',
    data: body
  })
  createSnackbar(REQUEST)
  return {
    type: "CREATE_PERMISSION_REQUIREMENT_CATEGORY",
    payload: REQUEST
  }
}

export const createPermissionsRequirementAction = body => {
  const REQUEST = instance({
    method: 'post',
    url: 'settings/permissions/requirements/create.php',
    data: body
  })
  createSnackbar(REQUEST)
  return {
    type: "CREATE_PERMISSION_REQUIREMENT",
    payload: REQUEST
  }
}

export const editPermissionsRequirementCategoryAction = body => {
  const REQUEST = instance({
    method: 'post',
    url: 'settings/permissions/requirements/edit_category.php',
    data: body
  })
  createSnackbar(REQUEST)
  return {
    type: "EDIT_PERMISSION_REQUIREMENT_CATEGORY",
    payload: REQUEST
  }
}

export const editPermissionsRequirementAction = body => {
  const REQUEST = instance({
    method: 'post',
    url: 'settings/permissions/requirements/edit.php',
    data: body
  })
  createSnackbar(REQUEST)
  return {
    type: "EDIT_PERMISSION_REQUIREMENT",
    payload: REQUEST
  }
}

export const deletePermissionsRequirementCategoryAction = body => {
  const REQUEST = instance({
    method: 'post',
    url: 'settings/permissions/requirements/delete_category.php',
    data: body
  })
  createSnackbar(REQUEST)
  return {
    type: 'DELETE_PERMISSION_REQUIREMENT_CATEGORY',
    payload: REQUEST
  }
}